import styled from 'styled-components';
import Card from '@material-ui/core/Card';

export const Container = styled.div`
  display: flex;
  & > * {
    margin-right: 10px;
  }
`;

export const StyledCard = styled(Card)`
  width: 100px;
  height: 120px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 1s !important;
  & span.badge {
    opacity: 0;
    position: absolute;
    top: 10px;
    right: 10px;
    transition: 1s;
  }
  & span.text {
    position: absolute;
    bottom: 10px;
    text-align: center;
    width: 100%;
  }
  & span.icon {
  }
  &:hover {
    transition: 1s;
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: white;
  }

  ${({ active }) =>
    active &&
    `span.badge {
      opacity:1;
      transition: 1s;
    }
  `}
`;
